import { defineAsyncComponent } from 'vue'
export default {
  article: defineAsyncComponent(() => import("/opt/build/repo/layouts/article.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/opt/build/repo/layouts/default.vue").then(m => m.default || m)),
  page: defineAsyncComponent(() => import("/opt/build/repo/layouts/page.vue").then(m => m.default || m))
}